<div>
  <br/>
  <h2 class="align-center">{{ 'Tillgängliga produkter' | translate }}</h2>
  <mat-tab-group>
    <mat-tab [label]="'T-Shirts' | translate" *ngIf="availableClothes['TSHIRT']" #tShirtsTab>
      <div *ngIf="tShirtsTab.isActive" class="product-overview-container row">
        <div class="product col-3" *ngFor="let product of availableClothes['TSHIRT']">
          <img
            src="/api/stores/public/{{globals.storeId}}/products/clothes/product-image/{{product.model}}/{{product.color}}" />
          <div class="product-name">{{product.name}}</div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="'Hoodies' | translate" *ngIf="availableClothes['HOODIE']" #hoodieTab>
      <div *ngIf="hoodieTab.isActive" class="product-overview-container row">
        <div class="product col-3" *ngFor="let product of availableClothes['HOODIE']">
          <img
            src="/api/stores/public/{{globals.storeId}}/products/clothes/product-image/{{product.model}}/{{product.color}}" />
          <div class="product-name">{{product.name}}</div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="'Sweatshirts' | translate" *ngIf="availableClothes['SWEATSHIRT']" #hoodieTab>
      <div *ngIf="hoodieTab.isActive" class="product-overview-container row">
        <div class="product col-3" *ngFor="let product of availableClothes['SWEATSHIRT']">
          <img
            src="/api/stores/public/{{globals.storeId}}/products/clothes/product-image/{{product.model}}/{{product.color}}" />
          <div class="product-name">{{product.name}}</div>
        </div>
      </div>
    </mat-tab>

    <mat-tab [label]="'Barn' | translate" *ngIf="availableClothes['KIDS']" #hoodieTab>
      <div *ngIf="hoodieTab.isActive" class="product-overview-container row">
        <div class="product col-3" *ngFor="let product of availableClothes['KIDS']">
          <img
            src="/api/stores/public/{{globals.storeId}}/products/clothes/product-image/{{product.model}}/{{product.color}}" />
          <div class="product-name">{{product.name}}</div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
